/**
 * Return the height of the viewport. This probably needs to be more thorough.
 */
const getViewportHeight = () => {
  return window.innerHeight;
};
export default getViewportHeight;